import {Pipe, PipeTransform} from '@angular/core';
import {Language} from '../../enums/language.enum';

@Pipe({
  name: 'toNativeLanguageName',
})
export class NativeLanguageNamePipe implements PipeTransform {
  private languageToNativeName: Record<Language, string> = {
    [Language.GERMAN]: 'Deutsch',
    [Language.ENGLISH]: 'English',
    [Language.SPANISH]: 'Español',
    [Language.SPANISH_LATIN_AMERICAN]: 'Español latinoamericano',
    [Language.FRENCH]: 'Français',
    [Language.ITALIAN]: 'Italiano',
    [Language.JAPANESE]: '日本語',
    [Language.KOREAN]: '한국어',
    [Language.POLISH]: 'Polski',
    [Language.PORTUGUESE]: 'Português do Brasil',
    [Language.RUSSIAN]: 'Русский',
    [Language.THAI]: 'Thai',
    [Language.TURKISH]: 'Türkçe',
    [Language.VIETNAMESE]: 'tiếng việt',
    [Language.CHINESE_SIMPLIFIED]: '简体中文',
    [Language.CHINESE_TRADITIONAL]: '繁體中文',
  };

  transform(value: Language): string {
    return this.languageToNativeName[value];
  }
}
